import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-bogo-offer-popup',
  templateUrl: './bogo-offer-popup.component.html',
  styleUrls: ['./bogo-offer-popup.component.scss']
})
export class BogoOfferPopupComponent implements OnInit {

  constructor(private router: Router,
    private UTS: UtilitiesService,
    private modalController: ModalController
  ) { }

  ngOnInit(): void {
  }

  redirectToPacksSelection(){
    let url = '/choose-packs?flow=bogoOffer&lang=' + this.UTS.getLocaleLanguage();
    this.router.navigateByUrl(url);
    this.dismissAllModals();
  }
  close(){
    this.modalController.dismiss({ proceedNow: true});
  }
  async dismissAllModals() {
    const topModal = await this.modalController.getTop();
    if (topModal) {
      await this.modalController.dismiss();
      this.dismissAllModals();  // recursively dismiss all modals
    }
  }
}
